import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(o, a) {
  return e(), t("svg", c, [...a[0] || (a[0] = [
    l("g", { "clip-path": "url(#a)" }, [
      l("path", {
        fill: "currentColor",
        d: "M18.113 12.784c.032-.256.057-.512.057-.784s-.025-.528-.057-.784l1.735-1.32a.396.396 0 0 0 .099-.512l-1.645-2.768a.41.41 0 0 0-.362-.2.4.4 0 0 0-.14.024l-2.048.8a6 6 0 0 0-1.39-.784l-.312-2.12A.4.4 0 0 0 13.647 4h-3.29a.4.4 0 0 0-.403.336l-.313 2.12c-.501.2-.962.472-1.39.784l-2.047-.8a.5.5 0 0 0-.148-.024.41.41 0 0 0-.354.2L4.057 9.384a.387.387 0 0 0 .099.512l1.735 1.32c-.033.256-.058.52-.058.784s.025.528.058.784l-1.735 1.32a.396.396 0 0 0-.099.512l1.645 2.768c.074.128.214.2.362.2q.076 0 .14-.024l2.047-.8q.64.482 1.39.784l.313 2.12a.4.4 0 0 0 .403.336h3.29a.4.4 0 0 0 .403-.336l.312-2.12c.502-.2.963-.472 1.39-.784l2.048.8q.075.024.148.024a.41.41 0 0 0 .354-.2l1.645-2.768a.396.396 0 0 0-.1-.512zm-1.629-1.368a4.1 4.1 0 0 1 .001 1.168l-.116.904.732.56.888.672-.576.968-1.044-.408-.855-.336-.74.544a5 5 0 0 1-1.029.584l-.871.344-.132.904-.165 1.08h-1.15l-.157-1.08-.132-.904-.871-.344a4.7 4.7 0 0 1-1.012-.568l-.749-.56-.871.344-1.045.408-.576-.968.889-.672.732-.56-.115-.904A6 6 0 0 1 7.478 12c0-.16.017-.344.042-.584l.115-.904-.732-.56-.889-.672.576-.968 1.045.408.855.336.74-.544a5 5 0 0 1 1.028-.584l.872-.344.132-.904.164-1.08h1.143l.157 1.08.131.904.872.344c.354.144.683.328 1.012.568l.748.56.872-.344 1.044-.408.576.968-.88.68-.732.56zM12.002 8.8c-1.818 0-3.29 1.432-3.29 3.2s1.472 3.2 3.29 3.2c1.817 0 3.29-1.432 3.29-3.2s-1.473-3.2-3.29-3.2m0 4.8c-.905 0-1.645-.72-1.645-1.6s.74-1.6 1.645-1.6c.904 0 1.645.72 1.645 1.6s-.74 1.6-1.645 1.6"
      })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
